import React, {useContext, useRef} from "react"
import { Grid, TextField, Divider} from "@material-ui/core"
import { BrowserView, MobileView } from "react-device-detect"
import FlexView from "react-flexview/lib"
import { useForm } from 'react-hook-form'
import { SessionContextStore } from "../../../context/SessionContext"
import { EventEmitterService, EventKey } from "../../../services/EventEmitterService"
import '../UserProfile.scss'
import { ACTIONS, UserProfileContextStore } from "../../../context/UserProfileContext"
import { Action } from "../../../models/Action"
import { SessionService } from "../../../services/SessionService"
import {EMAIL_REGEX} from '../../../Constants'

export const AgentSection = () => {
    const profileContext = useContext(UserProfileContextStore)
    const sessionContext = useContext(SessionContextStore)
    const { register, watch, triggerValidation, setValue, errors, control, getValues } = useForm(SessionService.isLoggedIn() ? 
        {
            defaultValues: {
                agent_name: sessionContext.user.agentName,
                agent_email: sessionContext.user.agentEmail,
            },
            mode: 'onChange'
        } : { mode: 'onChange' })
    const agentNameWatch = watch('agent_name', sessionContext.user.agentName)
    const agentEmailWatch = watch('agent_email', sessionContext.user.agentName) 
    const validateEmail = email => !email || EMAIL_REGEX.test(email);

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.USER_PROFILE_SAVE, async () => {
            let valid = await triggerValidation()
            if(valid) {
                profileContext.dispatch(new Action(ACTIONS.SAVE_AGENT_INFO, getValues()))
            }
        })

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id)
        }
    }, [])

    React.useEffect(() => {
        setValue('agent_name', sessionContext.user.agentName)
        setValue('agent_email', sessionContext.user.agentEmail)
    }, [sessionContext.user])

    return (
        <React.Fragment>
            <BrowserView>
                <div className="text-title blue bold">Agency Details</div>
                <Divider />
                <Grid container spacing={2}>
                    <Grid item xs={12} md>
                        <FlexView>
                            <TextField InputLabelProps={{ shrink: !!agentNameWatch }} fullWidth variant="outlined"  autoFocus  label="Agent name" name="agent_name"  inputRef={register({required: true})} error={!!errors.agent_name} />
                            <TextField InputLabelProps={{ shrink: !!agentEmailWatch }} fullWidth variant="outlined" disabled={SessionService.isLoggedIn()} className="margin-left-basic" label="Agent email" name="agent_email"  inputRef={register({validate: validateEmail, required: true})} error={!!errors.agent_email} helperText={!!errors.agent_email? 'Invalid email' : ''} />
                        </FlexView>
                    </Grid>
                </Grid>
            </BrowserView>
            <MobileView>
                        <TextField InputLabelProps={{ shrink: !!agentNameWatch }} fullWidth variant="outlined"  autoFocus className="margin-top-basic" label="Agent name" name="agent_name"  inputRef={register({required: true})} error={!!errors.agent_name} />
                        <TextField InputLabelProps={{ shrink: !!agentEmailWatch }} fullWidth variant="outlined" disabled={SessionService.isLoggedIn()} className="margin-top-basic" label="Agent email" name="agent_email"  inputRef={register({validate: validateEmail, required: true})} error={!!errors.agent_email} helperText={!!errors.agent_email? 'Invalid email' : ''} />
            </MobileView>
        </React.Fragment>
    )
}